module.exports = __webpack_public_path__ + "static/img/tst2-07.49e6dce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/tst2-07.jpg
// module id = VoG5
// module chunks = 1